import * as React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import HomeSectionsContainer from '../components/Home/HomeSections';
import NewsItemSummaryContainer from '../components/News/NewsItemSummary';

export type HomeProps = {
    // TODO: this could probably be a type somewhere
    history?: {
        push: Function;
    }
}

export type HomeAllProps = HomeProps;

export type HomeState = {
    redirectTo: string
}

@withRouter
export default class Home extends React.Component<HomeAllProps, HomeState> {
    constructor(props: HomeAllProps, context) {
        super(props, context);
        this.state = { redirectTo: undefined };
        this.onNodeClick = this.onNodeClick.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onNodeClick(redirectUrl) {
        this.props.history.push(redirectUrl);
    }

    render() {
        if (this.state.redirectTo) {
            return (
                <Redirect to={`/${this.state.redirectTo}`} />
            )
        } else {
            return (<div id="SectionsContainer">
                <HomeSectionsContainer />
                <NewsItemSummaryContainer />
            </div>);
        }
    }
}




// WEBPACK FOOTER //
// ./src/pages/Home.tsx